import { computed } from 'vue';
import { useWorkspaceSchemaStore } from '#layers/data-model/stores/workspace-schema';

export function useFileCollection() {
	const { findCollectionByName, findPrimitiveFieldByName, findSingleRelationFieldByName } = useWorkspaceSchemaStore();

	const collection = computed(() => findCollectionByName('MonospaceFile'));

	const titleField = computed(() => {
		if (!collection.value) return;
		return findPrimitiveFieldByName(collection.value, 'fileName');
	});

	const thumbnailField = computed(() => {
		if (!collection.value) return;
		return findSingleRelationFieldByName(collection.value, '$thumbnail');
	});

	const filesizeField = computed(() => {
		if (!collection.value) return;
		return findPrimitiveFieldByName(collection.value, 'fileSize');
	});

	const mediaTypeField = computed(() => {
		if (!collection.value) return;
		return findPrimitiveFieldByName(collection.value, 'mediaType');
	});

	const createdAtField = computed(() => {
		if (!collection.value) return;
		return findPrimitiveFieldByName(collection.value, 'createdAt');
	});

	return {
		collection,
		titleField,
		thumbnailField,
		filesizeField,
		mediaTypeField,
		createdAtField,
	};
}
